import React from "react";
import Popper from "@mui/material/Popper";
import Grow from "@mui/material/Grow";
import Paper from "@mui/material/Paper";
import ClickAwayListener from "@mui/material/ClickAwayListener";
import MenuList from "@mui/material/MenuList";
import { useMediaQuery } from "@mui/material";

export default function Menu({
  open,
  anchorRef,
  onClose,
  onListKeyDown,
  children,
}: IProps) {
  const isMobile = useMediaQuery("(max-width: 769px)");
  return (
    <Popper
      placement={isMobile ? "top" : "right-end"}
      sx={{
        zIndex: 999,
      }}
      open={open}
      anchorEl={anchorRef.current}
      transition
      disablePortal
      modifiers={[
        {
          name: "offset",
          options: {
            offset: isMobile ? [0, 10] : [0, 5],
          },
        },
      ]}
    >
      {({ TransitionProps, placement }) => (
        <Grow
          {...TransitionProps}
          style={{
            transformOrigin: "left top",
          }}
        >
          <Paper
            sx={{
              background: `${isMobile ? "#272727" : "#1e1e1e"}`,
              borderRadius: "10px",
              width: "200px",
            }}
          >
            <ClickAwayListener onClickAway={onClose}>
              <MenuList autoFocusItem={open} onKeyDown={onListKeyDown}>
                {children}
              </MenuList>
            </ClickAwayListener>
          </Paper>
        </Grow>
      )}
    </Popper>
  );
}

interface IProps {
  open: boolean;
  anchorRef: React.RefObject<HTMLElement>;
  // onClose: React.MouseEventHandler<EventTarget>;
  onClose: any;
  onListKeyDown: React.KeyboardEventHandler;
  children?: React.ReactNode;
}
